// removed by extract-text-webpack-plugin
module.exports = {"this":"_3Ul6KfSYT_B5XeJ3bhiYem","flipInX":"_1aY2OUc9PUO2RFbNhE_TW8","shade":"iPoeQ9BFU5I26GRX2oiPb","fadeIn":"yGKj1wpBCmq8hpOEwBUJ5","fadeInNormal":"_1zbAy2MS_lBRpAODi-EhID","popupLogo":"smIg9fl3p99oHQY0g7mef","main":"_21vwTGDxRaE4zZ_wPAIPhC","title":"RthbROnt5cPm5cSLuezo5","content":"_1KEq20A53LFMS7dovHincW","button":"_3kGZIgEYondVeyrPW5Y9Q9","cancel":"_3vya3fw6ZAp6_i5aarAyM"};


//////////////////
// WEBPACK FOOTER
// ./src/frame/ui/popup/AlertPopup.scss
// module id = 600
// module chunks = 12